import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

function BackButton({
  children = '返回',
  className = '',
  fallbackPath = '/',
}) {
  const navigate = useNavigate()

  const handleClick = () => {
    if (window.history.length > 1) {
      navigate(-1)
      return
    }
    navigate(fallbackPath)
  }

  return (
    <button className={`back-button ${className}`.trim()} type="button" onClick={handleClick}>
      <ArrowLeft size={16} />
      <span>{children}</span>
    </button>
  )
}

export default BackButton
